function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.56 1h-5.121v8.373l-2.013 1.593.001-2.937c0-1.02-.906-1.804-1.916-1.66l-.358.06c-3.551.676-6.21 3.707-6.377 7.326l-.004.169-.231.35C.516 15.877 0 17.51 0 19.407v7.052C-.005 27.854 1.138 28.993 2.552 29l.361-.008c4.183-.188 7.514-3.626 7.514-7.822v-3.704l4.572-3.618 4.571 3.618.001 3.704c0 4.316 3.526 7.83 7.868 7.83l.235-.012c1.312-.122 2.33-1.212 2.326-2.534l-.001-7.047-.011-.468c-.079-1.697-.59-3.193-1.53-4.664l-.232-.348.005.191c0-3.9-2.893-7.197-6.742-7.75a1.679 1.679 0 00-1.918 1.66v2.938L17.56 9.373V1z",
  fill: "currentColor"
})));